export default {
  panels: [],
  triggers: [],
  menu: null,
  openTrigger: null,
  openPanel: null,
  documentClickWrapped: null,
  init() {
    this.panels = [...document.querySelectorAll('[data-topnav-submenu]')];
    this.triggers = [...document.querySelectorAll('.nav-link[data-submenu-target]')];
    this.menu = document.querySelector('#topnav #menu');

    if (!this.panels.length || !this.triggers.length) return;

    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        this.toggleSubmenu(e, trigger);
      });
    });

    this.panels.forEach((panel) => {
      const submenuBackEl = panel.querySelector('.submenu-back');
      if (submenuBackEl) {
        submenuBackEl.addEventListener('click', () => {
          this.closeAll();
        });
      }
    });

    this.documentClickWrapped = (e) => {
      this.documentClick(e);
    };
  },
  getPanelForTrigger(trigger) {
    return (
      this.panels.find(
        (panel) => panel.dataset.topnavSubmenu === trigger.dataset.submenuTarget
      ) || null
    );
  },
  toggleSubmenu(e, trigger) {
    e.preventDefault();

    if (trigger === this.openTrigger && this.openPanel) {
      this.closeAll();
      return;
    }

    const panel = this.getPanelForTrigger(trigger);
    if (!panel) return;

    this.closeAll();
    this.openTrigger = trigger;
    this.openPanel = panel;

    trigger.classList.add('open');
    panel.classList.add('open');
    if (this.menu) this.menu.classList.add('submenu-open');

    panel.querySelectorAll('a').forEach((navLinkEl) => {
      navLinkEl.tabIndex = 0;
    });

    if (window.innerWidth >= 1200) {
      document.addEventListener('click', this.documentClickWrapped);
    }
  },
  documentClick(e) {
    if (
      e.target != this.openTrigger &&
      !e.target.closest('.topnav-submenu-inner')
    ) {
      this.closeAll();
    }
  },
  closeAll(burgerClose = false) {
    if (burgerClose && this.openPanel && this.menu) {
      this.menu.style = 'transition: unset';
      setTimeout(() => {
        this.menu.style = '';
      }, 600);
    }

    if (this.openTrigger) this.openTrigger.classList.remove('open');

    if (this.openPanel) {
      this.openPanel.classList.remove('open');
      this.openPanel.querySelectorAll('a').forEach((navLinkEl) => {
        navLinkEl.tabIndex = -1;
      });
    }

    if (this.menu) this.menu.classList.remove('submenu-open');

    if (window.innerWidth >= 1200) {
      document.removeEventListener('click', this.documentClickWrapped);
    }

    this.openTrigger = null;
    this.openPanel = null;
  },
};